(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["easyhear-review-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('eh-review-carousel')){
customElements.define('eh-review-carousel',class extends HTMLElement{
connectedCallback(){
this.track=this.querySelector('.eh-review-track');
this.prev=this.querySelector('.eh-review-prev');
this.next=this.querySelector('.eh-review-next');
if(!this.track)return;
this.update=()=>{this.prev.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;};
this.move=(direction)=>this.track.scrollBy({left:direction*(this.track.firstElementChild.getBoundingClientRect().width+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
this.prev.onclick=()=>this.move(-1);this.next.onclick=()=>this.move(1);
this.track.addEventListener('scroll',this.update,{passive:true});
this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update();
}
disconnectedCallback(){this.observer?.disconnect();this.track?.removeEventListener('scroll',this.update);}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltx-header"]) return;
  try {
    
document.querySelectorAll('.vx-hamburger').forEach(menu=>{document.addEventListener('click',event=>{if(!menu.contains(event.target))menu.open=false;});menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voltx-product"]) return;
  try {
    
document.querySelectorAll('[data-vx-purchase]').forEach(root=>{
const photos=[...root.querySelectorAll('[data-vx-photo]')],previous=root.querySelector('[data-vx-prev]'),next=root.querySelector('[data-vx-next]');
const selectPhoto=button=>{
const image=root.querySelector('#vx-main-photo'),url=button.dataset.vxPhoto;
image.src=url+'&width=1000';image.srcset=[400,700,1000].map(w=>url+'&width='+w+' '+w+'w').join(', ');image.alt=button.dataset.alt;
photos.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
const index=photos.indexOf(button);previous.disabled=index===0;next.disabled=index===photos.length-1;
button.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest',inline:'center'});
};
photos.forEach(button=>button.addEventListener('click',()=>selectPhoto(button)));
const movePhoto=direction=>{const index=photos.findIndex(button=>button.getAttribute('aria-pressed')==='true');selectPhoto(photos[Math.max(0,Math.min(photos.length-1,index+direction))]);};
previous.addEventListener('click',()=>movePhoto(-1));next.addEventListener('click',()=>movePhoto(1));
root.querySelectorAll('[data-vx-choice]').forEach(input=>input.addEventListener('change',()=>{
root.querySelectorAll('[data-vx-price]').forEach(price=>price.textContent=input.dataset.price);
const button=root.querySelector('[data-vx-add]');
if(button){button.disabled=input.dataset.available!=='true';button.textContent=button.disabled?button.dataset.unavailable:button.dataset.ready;}
}));
});

document.querySelectorAll('[data-vx-reviews]').forEach(root=>{
const track=root.querySelector('.vx-photo-track'),prev=root.querySelector('[data-review-prev]'),next=root.querySelector('[data-review-next]');
const update=()=>{prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;};
const move=direction=>track.scrollBy({left:direction*(track.querySelector('.vx-photo-card').getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
});

  } catch(e) { console.error(e); }
})();
})();
